import styled from '@emotion/styled';
import { Typography } from 'src/components-dummy';
import { Card } from 'src/components-dummy/Card';

export const RuleFormSectionStyled = styled(Card)`
  padding: 32px;
  margin-bottom: 24px;
  width: 90%;
`;

export const RuleFormSectionHeaderStyled = styled(Typography)`
  margin-bottom: 16px;
  display: block;
`;
